import { Divider, Drawer, Grid, Typography } from '@material-ui/core';
import { CadastroNotaComercialApiRequest } from 'common/genericTypes';
import UploadDocs, { Attachment } from 'components/uploadDocs';
import { Button, DatePicker, MdSpace, SmSpace } from 'm2m.components';
import { Dispatch, SetStateAction, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { dataAditamento } from 'store/modules/notaComercial/aditamento';
import NotaComercialParser from 'utils/parsers/notaComercialParser';
import { addAlert } from 'store/modules/snackBar';

export function FormularioDrawerAditamento({
  open,
  setOpen,
  handleSubmit,
  codigo,
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  handleSubmit: () => void;
  codigo: string;
}) {
  const dispatch = useDispatch();
  const [documento, setDocumento] = useState<File | undefined>();

  const caracteristicas = useSelector((state: RootState) => state.notaComercialCadastro.caracteristicas);
  const criteriosRemuneracao = useSelector((state: RootState) => state.notaComercialCadastro.criteriosRemuneracao);
  const eventos = useSelector((state: RootState) => state.notaComercialCadastro.eventos);
  const uploadDocumentos = useSelector((state: RootState) => state.notaComercialCadastro.uploadDocumentos);
  const emissor = useSelector((state: RootState) => state.notaComercialCadastro.emissor);
  const notaComercialId = useSelector((state: RootState) => state.notaComercialCadastro.caracteristicas.id);
  const dateAditamento = useSelector((state: RootState) => state.notaComercialCadastro.dataAditamento);

  const notaComercialApi = useSelector((state: RootState) => state.notaComercialApi);

  const handleUpdateFileToStore = (attachments: Attachment[]): void => {
    const newAttachment = attachments?.[0].file;
    setDocumento(newAttachment);
  };

  const submitPutNotaComercialAditamento = async (
    notaComercialId: string,
    notaComercial: CadastroNotaComercialApiRequest,
    file: File
  ): Promise<string> => {
    try {
      if (typeof dateAditamento !== 'undefined') {
        return await notaComercialApi.putNotaComercialAditamento(
          dispatch,
          notaComercialId,
          notaComercial,
          dateAditamento,
          file,
          true
        );
      } else throw 'Falta informações a serem aditadas';
    } catch (error: any) {
      console.log(error);
      dispatch(addAlert({ message: error, severity: 'error' }));
    }
    return codigo;
  };

  const handleAditamentoSubmit = async (): Promise<string | (() => void)> => {
    try {
      const notaComercial: CadastroNotaComercialApiRequest = NotaComercialParser.stateToCadastroNotaComercialApiRequest(
        caracteristicas,
        criteriosRemuneracao,
        eventos,
        uploadDocumentos,
        emissor
      );
      if (!notaComercialId) throw 'Erro ao aditar.';
      let notaComercialResponse;

      if (documento) {
        notaComercialResponse = await submitPutNotaComercialAditamento(notaComercialId, notaComercial, documento);
        if (!notaComercialResponse || notaComercialResponse.length === 0) throw 'Erro ao aditar';
        
        dispatch(addAlert({ message: notaComercialResponse, severity: 'success' }));
        handleSubmit();
      }
      if (!notaComercialResponse) throw 'Erro ao aditar';

      return notaComercialResponse;
    } catch (error: any) {
      dispatch(addAlert({ message: error.message, severity: 'error' }));

      throw error;
    }
  };

  const handleUpdateDataAditamento = (input: string | undefined): void => {
    dispatch(dataAditamento(input));
  };
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{ style: { padding: '40px', maxWidth: 460 } }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h3">{'Aditamento'}</Typography>
          <SmSpace />
          <Divider variant="fullWidth" />
          <MdSpace />
          <Typography variant="body2">{`Tem certeza que deseja solicitar aditamento do instrumento ${codigo}?`}</Typography>
          <SmSpace />
          <DatePicker
            value={undefined}
            label="Data do aditamento"
            onChange={(value) => handleUpdateDataAditamento(value?.format())}
          />
          <SmSpace />
          <UploadDocs
            aditamento={true}
            multipleFiles={false}
            inputAttachments={[]}
            onChange={handleUpdateFileToStore}
          />
          <MdSpace />
          <Button
            onClick={handleAditamentoSubmit}
            disabled={typeof documento === 'undefined'}
            variant="contained"
            color="primary"
            fullWidth
          >
            {'Solicitar Aditamento'}
          </Button>
          <SmSpace />
          <Button onClick={() => setOpen(false)} variant="contained" color="error" fullWidth>
            {'Cancelar'}
          </Button>
        </Grid>
      </Grid>
    </Drawer>
  );
}
